export default function() {
    if(document.querySelector('.header-inrijpoorten') === null) {
        return;
    }

    // jQuery UI ontbreekt soms (bijv. lokaal); voorkom dat de rest van app.js dan stopt
    if (typeof $.fn.selectmenu === 'function') {
        $('.header-inrijpoorten select').selectmenu();
    }
}